module.exports = __webpack_public_path__ + "img/tu02.a8ca17f9.jpg";